import { produce } from 'immer';
import {
  UPDATE_COUNTRIES,
  UPDATE_CONDITION_OPERATOR,
  UPDATE_JOB_LEVELS,
  UPDATE_METRIC_NAMES,
  UPDATE_TENURE_OPERATORS,
} from '../actions/initialzeDataActionTypes';
import mapOptions from '../util/segmentCreation/mapOptions';

const initialState = {
  countriesOptions: [],
  countries: [],
  conditionOperators: [],
  conditionOperatorOptions: [],
  jobLevels: [],
  metricNames: [],
  metricNamesOptions: [],
  tenureOperatorOptions: [],
};

export default function initializeData(state = initialState, action) {
  return produce(state, draftState => {
    switch (action.type) {
      case UPDATE_COUNTRIES:
        const countries = action.payload;
        draftState.countries = countries;
        const transformCountries = mapOptions(countries);
        draftState.countriesOptions = transformCountries || [];
        break;
      case UPDATE_CONDITION_OPERATOR:
        const operators = action.payload;
        draftState.conditionOperators = operators;
        const transformConditionOperators = mapOptions(operators);
        draftState.conditionOperatorOptions = transformConditionOperators || [];
        break;
      case UPDATE_JOB_LEVELS:
        const jobLevels = action.payload;
        draftState.jobLevels = jobLevels;
        break;
      case UPDATE_METRIC_NAMES:
        const metricNames = action.payload;
        draftState.metricNames = metricNames;
        const transformMetricNames = mapOptions(metricNames);
        draftState.metricNamesOptions = transformMetricNames || [];
        break;
      case UPDATE_TENURE_OPERATORS:
        const options = action.payload;
        const tenureOperatorOptions = mapOptions(options);
        draftState.tenureOperatorOptions = tenureOperatorOptions || [];
        break;
      default:
        break;
    }
  });
}
